<template>
	<div
		class="item-option menu-state-icon-primary px-3"
		@click="action(props.item)">
		<a
			class="d-flex item-menu justify-content-between align-items-center"
			:class="{ 'url-active': submenu_open || props.item.current }">
			<div class="menu-item align-items-center">
				<div>
					<a
						:href="props.item.url"
						class="menu-link d-flex"
						:class="{ active: submenu_open || props.item.current }">
						<span class="menu-icon">
							<div class="teste" v-html="props.item.icon"></div>
						</span>
						<span
							class="w-bold"
							:class="{
								'menu-text': !props.side_bar_menu_open,
								'menu-text-open': props.side_bar_menu_open,
								'fw-bold': props.item.current,
							}">
							{{ props.item.title }}
						</span>
					</a>
				</div>
			</div>
			<div class="d-flex align-items-center me-8">
				<i
					class="fa-solid fa-chevron-right"
					style="color: #9a9996"
					v-if="
						props.item.sub &&
						props.side_bar_menu_open &&
						!submenu_open
					">
				</i>
				<i
					class="fa-solid fa-chevron-down"
					style="color: #9a9996"
					v-if="
						props.item.sub &&
						props.side_bar_menu_open &&
						submenu_open
					">
				</i>
			</div>
		</a>
		<div
			v-if="props.item.sub && submenu_open"
			v-for="(sub, index) in props.item.sub"
			:key="index"
			@click="action(sub)"
			class="d-flex item-menu justify-content-start ms-5"
			:class="{ 'fw-bold url-active': sub.current }">
			<div class="menu-item">
				<a
					class="menu-link"
					:class="{ active: sub.current }"
					:href="sub.url">
					<span class="menu-icon">
						<div v-html="sub.icon"></div>
					</span>
					<span
						class="w-bold"
						:class="{
							'menu-text': !props.side_bar_menu_open,
							'menu-text-open': props.side_bar_menu_open,
						}">
						{{ sub.title }}
					</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { computed } from '@vue/reactivity';

	const props = defineProps({
		item: { type: Object, required: true },
		side_bar_menu_open: { type: Boolean, required: true },
	});

	const submenu_open = computed(() => {
		return !props.side_bar_menu_open
			? false
			: props.item.current && props.item.sub;
	});

	function action(item) {
		if (item.action) {
			item.action();
			return;
		}
		if (item.url) {
			window.location.href = item.url;
			return;
		}
		if (!item.url && !item.action) {
			props.item.current = !props.item.current;
			return;
		}
	}
</script>

<style>
	.menu-text {
		color: #9899ac;
		opacity: 0;
		transition: 0.3s;
		white-space: nowrap;
	}
	.menu-text-open {
		color: #9899ac;
		opacity: 1;
		transition: 0.3s;
	}
	.sidebar:hover .menu-text {
		opacity: 1;
	}
	.item-menu {
		cursor: pointer;
	}
	.item-menu:hover {
		background-color: #1b1b28;
	}

	.item-menu:hover .menu-text {
		color: #fff;
	}
	.item-menu:hover .menu-text-open {
		color: #fff;
	}
	.url-active span {
		color: #fff;
	}
	.url-active {
		background-color: #1b1b28;
	}
</style>
